application.register("comp_booking", class extends Stimulus.Controller {
    connect() {
        if (localStorage.getItem('lib-cookieconsent')) {
            document.getElementById('bookolo-engine').setAttribute('data-cookieconsent', JSON.parse(localStorage.getItem('lib-cookieconsent')).toString())
        }
    }
});
